import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import './PreviewSection.scss';

const isImageFile = file => file?.type?.startsWith('image/');

const PreviewSection = ({ messageHeadline, messageBody, attachmentFile }) => {
  const combinedMessage = useMemo(() => {
    const headline = messageHeadline.trim();
    const body = messageBody.trim();
    if (headline && body) return `${headline}\n\n${body}`;
    return headline || body || '';
  }, [messageHeadline, messageBody]);

  const attachmentPreviewUrl = useMemo(() => {
    if (!attachmentFile) return null;
    if (isImageFile(attachmentFile)) return URL.createObjectURL(attachmentFile);
    return null;
  }, [attachmentFile]);

  useEffect(() => {
    return () => {
      if (attachmentPreviewUrl) URL.revokeObjectURL(attachmentPreviewUrl);
    };
  }, [attachmentPreviewUrl]);

  const hasContent = combinedMessage || attachmentFile;

  return (
    <section className='preview-section announcements-section'>
      <h2 className='announcements-section-title'>Preview</h2>
      <div className='preview-section-chat-area'>
        {hasContent ? (
          <div className='preview-section-container'>
            <div className='preview-section-bubble'>
              {combinedMessage}
              {attachmentFile && (
                <>
                  {combinedMessage && <br />}
                  {attachmentPreviewUrl ? (
                    <img className='preview-section-image' src={attachmentPreviewUrl} alt={attachmentFile.name} />
                  ) : (
                    <span>
                      <span className='preview-section-file-name'>{attachmentFile.name}</span>
                      <span className='preview-section-file-size'> ({(attachmentFile.size / 1024).toFixed(1)} KB)</span>
                    </span>
                  )}
                </>
              )}
            </div>
          </div>
        ) : (
          <div className='preview-section-empty'>Fill in the message fields to see a preview.</div>
        )}
      </div>
    </section>
  );
};

PreviewSection.propTypes = {
  messageHeadline: PropTypes.string.isRequired,
  messageBody: PropTypes.string.isRequired,
  attachmentFile: PropTypes.object
};

export default PreviewSection;
